import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';

interface WhsSvgIconBaseProps extends IconBaseProps {
  children: React.ReactNode
}

const WhsIconBase: React.FC<WhsSvgIconBaseProps> = ({
  color = 'currentColor',
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  children,
}) => {
  return (
    <svg viewBox={viewBox} width={width} height={height} fill={color} data-testid="svg" aria-hidden="true">
      {children}
    </svg>
  );
};

export default WhsIconBase;
